import React from "react";

export const Logo = ({ size = 40, className = "" }) => (
  <img
    src="/branding/logo.png"
    alt="TSBRASIL Ar-Condicionado"
    width={size}
    height={size}
    className={`object-contain ${className}`}
    style={{ width: size, height: size }}
  />
);
